import { Component, inject } from '@angular/core';
import { LanguageService, languages } from '@catch/services';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslocoPipe } from '@jsverse/transloco';
import { EmbedService } from '../../../services/embed.service';
import { PrivacyModalComponent } from '../../snippets/privacy-modal/privacy-modal.component';
import { TargetBlankDirective } from '../../../directives/target-blank.directive';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [NgSelectModule, TranslocoPipe, PrivacyModalComponent, TargetBlankDirective],
})
export class FooterComponent {
  public readonly embedService = inject(EmbedService);
  public readonly languageService = inject(LanguageService);

  languages = languages;
}
